export const setSessionStorageData = (key: string, data: any) => {
  if (key && data) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
};

export const updateSessionStorageData = (key: string, params: { [name: string]: any; }) => {
  const data = { ...getSessionStorageData(key), ...params};
  if (data) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
};

export const removeSessionStorageData = (key: string, paramsKey: string) => {
  const currentData = getSessionStorageData(key);

  if (currentData) {
    delete currentData[paramsKey];
    sessionStorage.setItem(key, JSON.stringify(currentData));
  }
};

export const getSessionStorageData = (key: string) => {
  const data = sessionStorage.getItem(key);
  if (data) {
    return JSON.parse(data);
  }
};
